/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import logger from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import persistedReducer from '@/store';
import { ProvidersProps } from '../providers.types';

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    if (process.env.NODE_ENV !== 'production') {
      return middleware.concat(logger as any);
    }

    return middleware;
  },
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

const ReduxProvider: React.FC<ProvidersProps> = ({ children }) => (
  // @ts-ignore
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

export default ReduxProvider;
